import { apiRequest, fetchOnContent } from '@/common/utils/request.common'
import { HTTP_METHOD_GET } from '@/common/utils/request.const'
import _ from 'lodash'
import axios from 'axios'
import { EVENT_TYPE } from '@/common/resources/const'
import { getSectionEventByType } from '@/common/utils/gnb.fp'

const GNB_CATEGORY_MENU_URL = 'https://apis.wavve.com/cf/supermultisections/GN52?client=40'
export const GNB_CATEGORY_KEY = 'wavve_gnb_category_info'
export const CATEGORY_BAND_NUMBER_KEY = 'band_24'
export const CATEGORY_CTYPE_MENU = 'menu'
export const CATEGORY_CTYPE_MY = 'my'
export const CATEGORY_CTYPE_VOD = 'vod'
export const CATEGORY_CTYPE_VOD09 = 'vod09'
export const CATEGORY_CTYPE_MOVIE = 'movie'
export const CATEGORY_CTYPE_LIVE = 'live'
export const CATEGORY_CTYPE_MOVIEPLUS = 'movieplus'
export const EVENT_OPEN_CATEGORY_LAYOUT = 'event_open_category_layout'
export const EVENT_CLOSE_CATEGORY_LAYOUT = 'event_close_category_layout'
export const EVENT_OPEN_GNB_CATEGORY_MENU = 'event_open_gnb_category_menu'
export const EVENT_CLOSE_GNB_CATEGORY_MENU = 'event_close_gnb_category_menu'
export const EVENT_UPDATE_CATEGORY_COMPONENT = 'event_update_category_component'
export function fetchCategoryMultiSection () {
  return apiRequest({
    url: GNB_CATEGORY_MENU_URL,
    method: HTTP_METHOD_GET
  })
}

function CategoryMenuList () {
  this.multiSectionResponse = null
  this.sectionResponseMap = {}
}
CategoryMenuList.prototype.setMultiSectionResponse = function (multiSectionResponse) {
  this.multiSectionResponse = multiSectionResponse
}
CategoryMenuList.prototype.setSectionResponseMap = function (url, response) {
  this.sectionResponseMap[url] = response
}
CategoryMenuList.prototype.hasMultiSectionResponse = function () {
  return this.multiSectionResponse !== null
}
CategoryMenuList.prototype.hasCachedBandResponseByUrl = function (url) {
  return _.get(this.sectionResponseMap, url, null) !== null
}
CategoryMenuList.prototype.clearCache = function () {
  this.multiSectionResponse = null
  this.sectionResponseMap = {}
}

export const categoryInfo = new CategoryMenuList()

function fetchOnContentByStrategy (sectionInfo) {
  const onContent = getSectionEventByType(EVENT_TYPE.ON_CONTENT)(sectionInfo)
  const url = _.get(onContent, 'url', '')
  const isForceUpdate = _.get(sectionInfo, 'force_refresh', 'n').toUpperCase() === 'Y'
  const hasCached = categoryInfo.hasCachedBandResponseByUrl(url)
  if (url === '') { /* 멀티섹션이 이상한것 미리 걸러야 할것 */ }
  if (isForceUpdate || !hasCached) { // from remote
    return fetchOnContent(sectionInfo).then((response) => {
      categoryInfo.setSectionResponseMap(url, response)
      return response
    })
  } else { // from cached
    return new Promise((resolve) => {
      resolve(categoryInfo.sectionResponseMap[url])
    })
  }
}

function getSectionInfoByList (multiSectionList) {
  const reqList = multiSectionList.map((sectionInfo) => {
    return fetchOnContentByStrategy(sectionInfo)
  })
  return axios.all(reqList)
}

const getGenTime = multiSectionResponse => _.get(multiSectionResponse, 'data.gen_time', '')

export function setCategoryMenu () {
  return fetchCategoryMultiSection().then((response) => {
    const oldMultiSection = categoryInfo.multiSectionResponse
    const needNewMultiSection = oldMultiSection === null || (getGenTime(response) !== getGenTime(oldMultiSection))
    if (needNewMultiSection) {
      categoryInfo.setMultiSectionResponse(response)
    }
    return _.get(categoryInfo, 'multiSectionResponse.data.multisectionlist', [])
  }).then(getSectionInfoByList)
}
